export default "__VITE_ASSET__ab53d7fc__"